<template>
    <div class="toolbar">
        <div class="left">
            <slot name="left"></slot>
        </div>
        <div class="center">
            <slot name="center"></slot>
        </div>
        <div class="right">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'


    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {},
        computed: {},
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: '',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
.toolbar {
    background-color: $main-color;
    width: 100%;
    display: flex;
}
.sfr {
  .toolbar {
    background-color: $sfr-color;
    width: 100%;
    display: flex;
  }
}
.beepiz {
  .toolbar {
    background-color: $beepiz-color;
    width: 100%;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/ToolBar.vue